import React from "react";
import { Instagram, Heart, MessageCircle } from "lucide-react";
import { GALLERY, LINKS } from "../mock/data";
import useReveal from "../hooks/useReveal";

export default function InstagramSection() {
  const { ref, inView } = useReveal();
  const posts = GALLERY.slice(0, 6);
  return (
    <section className="bg-[#111] border-y border-white/10 py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""} text-center max-w-2xl mx-auto`}>
          <Instagram className="baja-red mx-auto mb-4" size={34} />
          <h2 className="font-display text-3xl md:text-5xl uppercase text-white">
            FOLLOW THE ADVENTURE
          </h2>
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-3 font-cond uppercase tracking-widest text-lg baja-red hover:text-white transition-colors"
          >
            @bajadesigns.in
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 mt-12">
          {posts.map((p) => (
            <a
              key={p.id}
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden"
            >
              <img
                src={p.image}
                alt="Instagram post"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
                <span className="flex items-center gap-1 text-white text-sm"><Heart size={16} fill="currentColor" /> {Math.floor(Math.random()*400+120)}</span>
                <span className="flex items-center gap-1 text-white text-sm"><MessageCircle size={16} /> {Math.floor(Math.random()*40+5)}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-baja-red hover:bg-[#ff1a44] text-white font-cond uppercase tracking-wider px-8 py-3.5 transition-colors"
          >
            <Instagram size={18} /> Follow on Instagram
          </a>
        </div>
      </div>
    </section>
  );
}
